<div class="page" data-theme="c"
  data-role="page"
  data-title="<%= string('champions') %> - <%= string('synergies') %>">
  <div id="header">
    <div class="buttons">
      <a class="ui-btn button stars" href="#" stars="1" data-ajax="false">
        <span class="narrow">1 ★</span>
        <span class="wide">★</span>
      </a>
      <a class="ui-btn button stars" href="#" stars="2" data-ajax="false">
        <span class="narrow">2 ★</span>
        <span class="wide">★ ★</span>
      </a>
      <a class="ui-btn button stars" href="#" stars="3" data-ajax="false">
        <span class="narrow">3 ★</span>
        <span class="wide">★ ★ ★</span>
      </a>
      <a class="ui-btn button stars" href="#" stars="4" data-ajax="false">
        <span class="narrow">4 ★</span>
        <span class="wide">★ ★ ★ ★</span>
      </a>
      <a class="ui-btn button stars" href="#" stars="5" data-ajax="false">
        <span class="narrow">5 ★</span>
        <span class="wide">★ ★ ★ ★ ★</span>
      </a>
    </div>
    <div class="ui-btn button legend">
      <span class="on">-</span>
      <span class="off">+</span>
    </div>
    <a class="ui-btn button share" href="#panel-options"
      data-rel="panel">
      <span>s</span>
    </a>
  </div>
  <canvas style="width:100%; height:100%;"></canvas>
  <div id="legend"></div>
  <div id="onboarding-synergies">
    <%= string('onboarding-synergies') %>
  </div>
</div>
